<template>
    <spinner-until :condition="!!exemption">
        <div class="exemption-view layout-max-width">

            <heading :title="`Review Exemption Request${vehicleId ? (': ' + vehicleId) : ''}`"
                     class="heading" tag="exemption-view-title">
                <div class="heading__buttons">
                    <b-dropdown variant="success" class="mr-3"
                                :disabled="!canGrant">
                        <template #button-content>
                            Grant
                            <b-icon-check-square/>
                        </template>
                        <b-dropdown-item @click="updateStatus('GRANTED', year1)">
                            Through {{ year1 }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="updateStatus('GRANTED', year2)">
                            Through {{ year2 }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="updateStatus('GRANTED', year3)">
                            Through {{ year3 }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="updateStatus('GRANTED', year4)">
                            Through {{ year4 }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="updateStatus('GRANTED', year5)">
                            Through {{ year5 }}
                        </b-dropdown-item>
                    </b-dropdown>
                    <b-btn variant="danger" class="mr-3"
                           :disabled="!canDeny"
                           @click="updateStatus('DENIED')">
                        Deny
                        <b-icon-x-square/>
                    </b-btn>
                    <b-btn variant="primary" class="mr-3"
                           :disabled="!canReset"
                           @click="updateStatus('PENDING')">
                        Reset Status
                        <b-icon-arrow-clockwise/>
                    </b-btn>
                    <b-btn variant="primary"
                           @click="showMessageModal()"
                           :disabled="!companyAdminUser">
                        Contact EO
                        <b-icon-box-arrow-right/>
                    </b-btn>
                </div>
            </heading>

            <spinner-until :condition="!updating">
                <b-row>
                    <b-col>
                        <b-card no-body>
                            <b-card-header>
                                <h5>Exemption Request</h5>
                            </b-card-header>
                            <b-card-body>
                                <view-table :model="exemptionFields"
                                            :data="exemption"
                                            :fields="['project.name', 'type', 'notes', 'status', 'granted_thru', 'expiration']">
                                    <template v-slot:status="slotProps">
                                        <exemption-status-badge :status="slotProps.value"/>
                                    </template>
                                </view-table>
                            </b-card-body>
                        </b-card>
                    </b-col>
                    <b-col>
                        <equipment-view-details v-if="exemption"
                                                :equipment="exemption.equipment"/>
                    </b-col>
                </b-row>

                <attachment-list class="mt-2"
                                 model-class="Exemption"
                                 model-table="exemption"
                                 help-tag="exemption-upload"
                                 :model-id="exemptionId"
                                 :readOnly="false"/>

                <h3 class="mt-5">Activity Log</h3>

                <log-entries table="exemption" :model-instance-id="exemptionId"/>
            </spinner-until>

            <message-create-modal :modalId="modalId"
                                  :recipient="companyAdminUser"/>

        </div>
    </spinner-until>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'
import ExemptionFields from '@/models/Exemption'

/**
 * Page for equipment owner (not admin) to view/review exemption
 */
export default Vue.extend({
    name: 'ExemptionView',
    props: {
        exemptionId: Number,
    },
    data () {
        const isAdmin = this.$user.isAdmin() || this.$user.isSuperAdmin()

        return {
            updating: false,
            year1: moment().format('Y'),
            year2: moment().add(1, 'year').format('Y'),
            year3: moment().add(2, 'year').format('Y'),
            year4: moment().add(3, 'year').format('Y'),
            year5: moment().add(4, 'year').format('Y'),
            exemption: null,
            equipment: null,
            vehicleId: '',
            exemptionFields: ExemptionFields,
            equipOwnerAdmin: null,
        }
    },
    computed: {
        companyId () {
            return this.equipment ? this.equipment.company_id : null
        },
        companyAdminUser () {
            return this.equipOwnerAdmin ? this.equipOwnerAdmin.companyAdminUser : null
        },
        canGrant () {
            return this.exemption && this.exemption.status === 'PENDING'
        },
        canDeny () {
            return this.exemption && this.exemption.status === 'PENDING'
        },
        canReset () {
            return this.exemption && (this.exemption.status === 'GRANTED' || this.exemption.status === 'DENIED')
        },
        hash () {
            return Math.random().toString(36).substr(2, 5)
        },
        modalId () {
            return 'message_modal' + this.hash
        },
    },
    methods: {
        async loadExemption () {
            const item = await this.$api.getItem(this, 'exemption', this.exemptionId, ['equipment', 'project', 'userLogs'])
            this.equipment = item.equipment
            this.vehicleId = item.equipment.vehicle_id
            this.exemption = item
            this.equipOwnerAdmin = await this.$api.getItem(this, 'company', this.equipment.company_id, ['companyAdminUser'])
        },
        async updateStatus (status, year = null) {
            try {
                this.updating = true
                await this.$api.updateExemptionStatus(this, this.exemption.id, status, year)
                this.loadExemption()
            } catch (e) {
                this.$toasted.error('Error: Cannot process Exemption Request')
            } finally {
                this.updating = false
            }
        },
        showMessageModal () {
            this.$bvModal.show(this.modalId)
        },
    },
    async mounted () {
        this.loadExemption()
    }
})

</script>
